import { render, staticRenderFns } from "./DownloadV3.vue?vue&type=template&id=06b9d405"
import script from "./DownloadV3.vue?vue&type=script&lang=js"
export * from "./DownloadV3.vue?vue&type=script&lang=js"
import style0 from "./DownloadV3.vue?vue&type=style&index=0&id=06b9d405&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports